import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

//Animate tiles is used on the masonry and gallery grid blocks

//Initialise tiles animation
function animateTiles() {
  const animatedElements = gsap.utils.toArray('.js-animate-tile')

  if (animatedElements.length > 0) {
    ScrollTrigger.batch(animatedElements, {
      onEnter: batch =>
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.25,
        }),
    })
  }
}
animateTiles()
